<template>
  <van-dialog v-model="tipFlag" title="提示" confirmButtonColor="#54B0FB" :show-confirm-button="false">
    <div class="content"> 
      填写考生信息时，请务必填写考生本人真实的手机号和身份证号。<span style="color:red">*否则将不能进行考试</span>
    </div>
    <van-divider></van-divider>
    <div class="confirm">
      <span @click="confirm">我知道了</span>
    </div>
  </van-dialog>
</template>

<script>

export default {
  data(){
    return {
      tipFlag: true,
    }
  },
  methods: {
    confirm: function() {
      this.tipFlag = false
    }
  }

}
</script>

<style scoped lang='less'>
.content{
  padding:30px 60px;
  font-size: 32px;
}
.confirm{
  display: flex;
  justify-content: center;
  align-items: center;
  color: #2196F3;
  padding-bottom: 16PX;
  span{
    cursor: pointer;
  }
}
::v-deep .van-dialog__header {
  font-size: 20PX;
  font-weight: 500;
}
</style>